// extracted by mini-css-extract-plugin
export default {"logo":"style_logo__HEsuF","title":"style_title__BlyJ3"};